import React from 'react'
import FormTypesList from '../../pages/Commercial/FormTypes/List'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const FormTypesRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute
      path="/commercial/formTypes"
      exact
      component={FormTypesList}
    />
  </CustomSwitch>
)
